/** Available budget request types */
export enum BudgetRequestTypeEnum {
  /** Part of budget plan */
  PLAN = 'PLAN',
  /** Part of expense balance transfer */
  TRANSFER_EXPENSE_BALANCES = 'TRANSFER_EXPENSE_BALANCES',
  /** Plan adjustment */
  ADJUSTMENT = 'ADJUSTMENT',
}
